import { memo } from 'react';

import { useSwimlaneState } from '@/common/components/ui/swimlane/context';
import type { TCardId } from '@/common/components/ui/swimlane/types';

import { Card } from './Card';

export const CardRenderer = memo(({ cardId, ...rest }: { cardId: TCardId }) => {
  const { getCardProps } = useSwimlaneState();
  const props = getCardProps(cardId);
  return props && <Card {...props} {...rest} />;
});
